import $ from "jquery";
import { safe$, forceFocus } from "../../utils/functions";
import { v4 as uuidv4 } from "uuid";

const $document = $(document);
const $body = $("body");

$document.on("click", ".modal-trigger", function () {
  const $trigger = $(this);
  const $targetModal = $($trigger.data("target"));
  openModal($targetModal, $trigger).then(
    () => undefined,
    (err) => console.log(err)
  );
});
$document.on("click", ".modal", function () {
  closeModal($(this)).then(
    () => undefined,
    (err) => console.log(err)
  );
});
$document.on("click", ".modal__close, .modal-close", function () {
  const $targetModal = $(this).closest(".modal");
  closeModal($targetModal).then(
    () => undefined,
    (err) => console.log(err)
  );
});
$document.on("keydown", (event) => {
  const $targetModal = $document.find(".modal--active");
  event.key === "Escape" &&
    $targetModal.length !== 0 &&
    $targetModal.attr("id") !== "signpost-modal" &&
    closeModal($targetModal).then(
      () => undefined,
      (err) => console.log(err)
    );
});
$document.on("click", ".modal__content > *", (event) =>
  event.stopPropagation()
);

export const openModal = (targetModal, trigger = null) =>
  new Promise((resolve, reject) => {
    targetModal = safe$(targetModal);
    !targetModal && reject("modal:targetModal:bad_type");
    targetModal.length === 0 && reject("modal:targetModal:undefined");

    if (trigger !== null) {
      trigger = safe$(trigger);
      !trigger && reject("modal:trigger:bad_type");
      trigger.length === 0 && reject("modal:trigger:undefined");

      const relationshipId = "modal-" + uuidv4();
      trigger.attr("data-id", relationshipId);
      targetModal.attr("data-openedby", relationshipId);
    }

    if (!targetModal.hasClass("modal--active")) {
      $body.addClass("body--scroll-lock");
      targetModal.trigger("modal:opening");
      targetModal.addClass("modal--active").one("transitionend", () => {
        targetModal.trigger("modal:opened");
        resolve("modal:opened");
      });
    } else resolve("modal:already_opened");
  });

export const closeModal = (targetModal) =>
  new Promise((resolve, reject) => {
    targetModal = safe$(targetModal);
    !targetModal && reject("modal:targetModal:bad_type");
    targetModal.length === 0 && reject("modal:targetModal:undefined");

    if (targetModal.hasClass("modal--active")) {
      targetModal.trigger("modal:closing");
      targetModal.removeClass("modal--active").one("transitionend", () => {
        $body.removeClass("body--scroll-lock");
        targetModal.trigger("modal:closed");
        const $trigger = safe$(
          `.modal-trigger[data-id="${targetModal.attr("data-openedby")}"]`
        );
        $trigger && $trigger.length === 1 && forceFocus($trigger);
        resolve("modal:closed");
      });
    } else resolve("modal:already_closed");
  });
